import { render, staticRenderFns } from "./transactions.vue?vue&type=template&id=5578a244&scoped=true"
import script from "./transactions.vue?vue&type=script&lang=js"
export * from "./transactions.vue?vue&type=script&lang=js"
import style0 from "./transactions.vue?vue&type=style&index=0&id=5578a244&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5578a244",
  null
  
)

export default component.exports